var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"ds-control ds-no-padding el-col",class:_vm.getCss,style:(_vm.getStyle),attrs:{"slot-name":"default"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }